import React, { useState } from 'react';
import { getAIUColor } from '../../utils/aiuParse';
import './AIULegend.css';

interface AIULegendItem {
  value: number | undefined;
  label: string;
  interpretation: string;
}

const AIU_LEGEND_ITEMS: AIULegendItem[] = [
  {
    value: 0,
    label: 'AIU 0',
    interpretation: 'No anomaly detected'
  },
  {
    value: 1,
    label: 'AIU 1',
    interpretation: 'Visible Anomaly'
  },
  {
    value: 2,
    label: 'AIU 2',
    interpretation: 'Identifiable Anomaly'
  },
  {
    value: 3,
    label: 'AIU 3',
    interpretation: 'Unique Identifiable Anomaly'
  },
  {
    value: undefined,
    label: 'No Data',
    interpretation: 'AIU index not available'
  }
];

interface AIULegendProps {
  visible?: boolean;
  onToggleVisibility?: () => void;
  showInterpretations?: boolean;
}

const AIULegend: React.FC<AIULegendProps> = ({
  visible = true,
  onToggleVisibility,
  showInterpretations = true
}) => {
  const [interpretationsVisible, setInterpretationsVisible] = useState(showInterpretations);

  const toggleInterpretations = () => {
    setInterpretationsVisible(!interpretationsVisible);
  };

  if (!visible) return null;

  return (
    <div className="aiu-legend">
      <div className="aiu-legend-header">
        <h4>AIU Index Legend</h4>
        {onToggleVisibility && (
          <button
            className="legend-close-btn"
            onClick={onToggleVisibility}
            aria-label="Close legend"
          >
            ×
          </button>
        )}
      </div>

      <div className="aiu-legend-items">
        {AIU_LEGEND_ITEMS.map((item, index) => (
          <div key={index} className="aiu-legend-item">
            <div className="aiu-legend-marker">
              <svg height="12" width="12" viewBox="0 0 100 100">
                <circle
                  cx="50"
                  cy="50"
                  r="40"
                  stroke="#000"
                  strokeWidth="6"
                  fill={getAIUColor(item.value)}
                />
                <circle cx="50" cy="50" r="15" fill="#000" />
              </svg>
            </div>
            <div className="aiu-legend-text">
              <span className="aiu-legend-label">{item.label}</span>
              {interpretationsVisible && (
                <span className="aiu-legend-interpretation">
                  {item.interpretation}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="aiu-legend-controls">
        <button
          className="interpretation-toggle"
          onClick={toggleInterpretations}
        >
          {interpretationsVisible ? 'Hide' : 'Show'} Interpretations
        </button>
      </div>
    </div>
  );
};

export default AIULegend;
